import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';

const ConsentPopup = ({
    t, content, open, handleClose
}) => {
    const rootElement = document.getElementById('root');

    return rootElement ? createPortal(
        <div className={ cx('rodo-popup-container', { open }) }>
            <div className="rodo-popup">
                <div className="rodo-content" dangerouslySetInnerHTML={ { __html: content } }/>
                <div className="form-button form-button-gray">
                    <button onClick={ handleClose }>{ t('consent.common.button') }</button>
                </div>
            </div>
        </div>,
        rootElement
    ) : null;
};

ConsentPopup.propTypes = {
    t: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
};

export default ConsentPopup;



// WEBPACK FOOTER //
// ./src/components/content/common/ConsentPopup.jsx